import { api } from "@/lib/api";

const KEY = "mr-chat-queue";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
const write = (q) => localStorage.setItem(KEY, JSON.stringify(q));

export const queued = (convId) => read().filter((i) => i.convId === convId);

export function enqueue(convId, payload) {
  write([...read().filter((i) => i.payload.client_id !== payload.client_id), { convId, payload, at: Date.now() }]);
}

export function dequeue(clientId) {
  write(read().filter((i) => i.payload.client_id !== clientId));
}

let flushing = false;
export async function flushQueue() {
  if (flushing || !navigator.onLine) return;
  flushing = true;
  try {
    for (const item of read()) {
      try {
        const { data } = await api.post(`/conversations/${item.convId}/messages`, item.payload);
        dequeue(item.payload.client_id);
        window.dispatchEvent(new CustomEvent("mr-queue-sent", { detail: { convId: item.convId, message: data } }));
      } catch (e) {
        if (e.response && e.response.status < 500 && e.response.status !== 429) dequeue(item.payload.client_id);
        else break;
      }
    }
  } finally {
    flushing = false;
  }
}

export function startQueueWorker() {
  window.addEventListener("online", flushQueue);
  const t = setInterval(flushQueue, 15000);
  flushQueue();
  return () => {
    window.removeEventListener("online", flushQueue);
    clearInterval(t);
  };
}
